export default __webpack_public_path__ + "aea8faf2ee30a3bf28189e8c301bf108.svg";